module.exports = __webpack_public_path__ + "img/img50.988bf12e.svg";